// categoryIcons.tsx
import {
    Build as BuildIcon,
    CardGiftcard as CardGiftcardIcon,
    ChildFriendly as ChildFriendlyIcon,
    Construction as ConstructionIcon,
    DevicesOther as DevicesOtherIcon,
    DirectionsCar as DirectionsCarIcon,
    ElectricalServices as ElectricalServicesIcon,
    Pets as PetsIcon,
    SelfImprovement as SelfImprovementIcon,
    Snowboarding as SnowboardingIcon,
    SportsHandball as SportsHandballIcon
} from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import { man, women, religious, pApple } from '../../assests/icons';
import i18n from '../../services/localization/i18n';
import { Category } from '../../types';
// CategoryIcons.tsx


/**
 * A single-colour picture icon painted in the current text colour: the PNG is used as a mask
 * (its transparency is the shape) over `currentColor`, so it follows light/dark mode and hover
 * exactly like the SVG icons instead of staying a fixed teal picture.
 */
const PictureIcon = ({ src, width, height }: { src: string; width: number; height: number }) => (
    <Box
        component="span"
        aria-hidden="true"
        sx={{
            display: 'inline-block',
            width,
            height,
            bgcolor: 'currentColor',
            WebkitMask: `url("${src}") center / contain no-repeat`,
            mask: `url("${src}") center / contain no-repeat`
        }}
    />
);

// 👇 no more dumb sparse arrays, use a proper record
 export const categoryIcons: Record<number, React.ReactNode> = {
    1: <DirectionsCarIcon fontSize="large" />,
    30: <SelfImprovementIcon fontSize="large" />,
    76773: <ChildFriendlyIcon fontSize="large" />,
    76775: <PictureIcon src={man} width={30} height={35} />,
    76772: <PictureIcon src={women} width={30} height={35} />,
    76774: <PictureIcon src={religious} width={27} height={35} />,
    76776: <SnowboardingIcon fontSize="large" />,
    1945: <ConstructionIcon fontSize="large" />,
    5: <SportsHandballIcon fontSize="large" />,
    74431: <PetsIcon fontSize="large" />,
    76777: <BuildIcon fontSize="large" />,
    6: <ElectricalServicesIcon fontSize="large" />,
    76778: <DevicesOtherIcon fontSize="large" />,
    76705: <PictureIcon src={pApple} width={24} height={35} />,
    74405: <CardGiftcardIcon fontSize="large" />
};






interface Props {
  data: Category[];
  getByCategoryId: (id: number, name: string) => void;
}

const CategoryIcons: React.FC<Props> = ({ data, getByCategoryId }) => {
  return (
    <Box>
      {data.map((item) => (
        <Paper
          key={item.categoryId}
          onClick={() => getByCategoryId(item.categoryId, item[`name_${i18n.language}` as keyof Category] as string)}
          sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', padding: 2 }}
        >
          {categoryIcons[item.categoryId]}
          <Typography>{item[`name_${i18n.language}` as keyof Category]}</Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default CategoryIcons;
